module.exports = __webpack_public_path__ + "img/rightArrow.1d61aa14.svg";